import { ReactNode } from "react";
import {
  AdvancedReportFilterType,
  AdvancedReportValueType,
} from "./useAdvancedReport";
import useAdvancedReportData, {
  AdvancedReportDataContext,
} from "./useAdvancedReportData";

export interface AdvancedReportDataProviderProps {
  children?: ReactNode;
  visibleValues?: AdvancedReportValueType[];
  visibleFilters?: AdvancedReportFilterType[];
}

const AdvancedReportDataProvider: React.FC<AdvancedReportDataProviderProps> = ({
  children,
  visibleValues,
  visibleFilters,
}) => {
  const context = useAdvancedReportData({
    visibleValues,
    visibleFilters,
  });

  return (
    <AdvancedReportDataContext.Provider value={context}>
      {children}
    </AdvancedReportDataContext.Provider>
  );
};
export default AdvancedReportDataProvider;
